import {FC, useContext} from 'react';
import {Draggable} from 'react-beautiful-dnd';
import Drag from 'src/components/ui-icons/Drag';
import Edit from 'src/components/ui-icons/Edit';
import Trash from 'src/components/ui-icons/buttons/Trash';
import {TestContext} from '../../store/testContext';
import {deleteQuestion} from '../../store/testActions';
import {IQuestion} from '../../types';
import Cross from 'src/components/ui-icons/Cross';
import Mark from 'src/components/ui-icons/Mark';

interface IProps {
  index: number;
  question: IQuestion;
  handleChangeQuestion: () => void;
}

const QuestionCard: FC<IProps> = ({index, question, handleChangeQuestion}) => {
  const {dispatch} = useContext(TestContext);
  const handleDeleteQuestion = () => {
    dispatch(deleteQuestion(question.ID));
  };

  return (
    <Draggable draggableId={question.ID} index={index}>
      {provided => (
        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className="p-5 bg-[#F3F4F6] rounded-md mb-[10px] last:mb-0">
          <div className="flex justify-between items-center mb-5">
            <div className="flex gap-[10px]">
              <button className="hover:cursor-grab">
                <Drag />
              </button>
              <p className="flex items-center text-[18px] font-medium text-black">{question.Description}</p>
            </div>
            <div>
              <button onClick={handleChangeQuestion} type="button" className="mr-[10px]">
                <Edit />
              </button>
              <button type="button" onClick={handleDeleteQuestion}>
                <Trash />
              </button>
            </div>
          </div>
          <div>
            {question.Answers.map(answer => (
              <div className="flex gap-[10px] mb-5" key={answer.ID}>
                <div className="w-6 flex justify-center items-center">{answer.IsCorrect ? <Mark /> : <Cross />}</div>
                {answer.Description}
              </div>
            ))}
          </div>
        </div>
      )}
    </Draggable>
  );
};
export default QuestionCard;
